import { render, staticRenderFns } from "./HelpSlackDialog.vue?vue&type=template&id=f2282546&scoped=true&"
import script from "./HelpSlackDialog.vue?vue&type=script&lang=js&"
export * from "./HelpSlackDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2282546",
  null
  
)

export default component.exports